import { Interpolation } from "@emotion/core";
import { darken } from "polished";
import { Colors } from "../../../../design-tokens/colors";
import { DarkTheme, Device } from "../../../../design-tokens/media-queries";
import { Border } from "../../../../design-tokens/borders";
import { grid } from "../../../../design-tokens/grid";
import { Fonts } from "../../../../design-tokens/fonts";

const tableOutMostContainer: Interpolation = {
  marginBottom: grid(3),

  [Device.Mobile]: {
    display: "flex",
    overflow: "auto",
    marginLeft: grid(-2),
    marginRight: grid(-2),
  },
};

const tableOuterContainer: Interpolation = {
  [Device.Mobile]: {
    paddingLeft: grid(2),
    paddingRight: grid(2),
  },
};

const tableContainer: Interpolation = {
  borderRadius: Border.Radius,
  overflow: "hidden",

  [Device.Mobile]: {
    minWidth: grid(80),
  },
};

const header: Interpolation = {
  display: "flex",
  justifyContent: "space-between",
  fontSize: "12px",
  lineHeight: "15px",
  fontWeight: Fonts.Weight.SemiBold,
  padding: `${grid(1)} ${grid(2)}`,
  backgroundColor: darken(0.03, Colors.LightGrey),

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeDeepBlack,
  },
};

const tableBody: Interpolation = {
  position: "relative",
  backgroundColor: Colors.LightGrey,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },
};

const chartBackground: Interpolation = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 0,
};

const timeLabel: Interpolation = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  height: grid(2.5),
  color: Colors.White,
  fontSize: "12px",
  fontWeight: Fonts.Weight.Bold,
  padding: `${grid(0.5)} ${grid(1)}`,
  backgroundColor: Colors.Blue,
  borderRadius: Border.RadiusSm,
  marginBottom: grid(2),
};

const policyHeading: Interpolation = {
  fontSize: "22px",
  lineHeight: "25px",
  fontWeight: Fonts.Weight.Bold,
  marginBottom: grid(2),
};

const policyDetail: Interpolation = {
  [Device.Mobile]: { fontSize: "14px" },
};

const eventDescription: Interpolation = {
  transition: "all 0.2s ease",
  overflow: "hidden",
  textOverflow: "ellipsis",
  marginBottom: grid(3),
  a: {
    wordBreak: "break-word",
  },

  [Device.Mobile]: { fontSize: "14px" },
};

const resIndexDetail: Interpolation = {
  fontSize: "14px",
  marginBottom: grid(4),
};

const styles = {
  tableOutMostContainer,
  tableOuterContainer,
  tableContainer,
  tableBody,
  header,
  chartBackground,
  timeLabel,
  policyHeading,
  policyDetail,
  eventDescription,
  resIndexDetail,
};

export default styles;
